import router from '@/router'
import store from '@/store'
import { Http } from 'vue-resource'

export class RequestService {
  pendingPromises = {}
  authHeader () {
    if (store.getters['state/token']) {
      return { 'x-api-key': store.getters['state/token'] }
    } else {
      router.push({ name: 'unauthorized' })
      return null
    }
  }
  setPromise (route, method, body, params, promise, headers) {
    this.pendingPromises[route] = {
      promise,
      body,
      method,
      params,
      route,
      headers: JSON.stringify(headers)
    }
  }
  getPromise (route, method, body, params, headers) {
    const saved = this.pendingPromises[route]
    if (saved && typeof saved !== 'undefined' && saved.body === body && saved.method === method && saved.params === params && saved.headers === JSON.stringify(headers)) {
      return saved.promise
    } else {
      return null
    }
  }
  removePromise (route, method, body, params, headers) {
    const saved = this.pendingPromises[route]
    if (saved && saved.body === body && saved.method === method && saved.params === params && saved.headers === JSON.stringify(headers)) {
      this.pendingPromises[route] = null
    }
  }
  async makePromise (route, method, { body, params, noAuth }, mappingFunction) {
    var headers
    if (!noAuth) {
      if (!this.authHeader()) {
        return new Promise((resolve, reject) => {
          reject(new Error())
        })
      }
      headers = this.authHeader()
    }
    const currentPromise = this.getPromise(route, method, body, params, headers)
    if (currentPromise) {
      return currentPromise
    }
    const promise = new Promise(async (resolve, reject) => {
      if (noAuth || (!noAuth && headers)) {
        if (method === 'get' || method === 'delete') {
          Http[method](route, {
            headers: headers || {},
            params: params || null
          }).then(
            data => {
              resolve(mappingFunction(data.body))
            },
            error => {
              reject(error)
            }
          ).finally(() => {
            this.removePromise(route, method, body, params, headers)
          })
        } else {
          Http[method](route, body, {
            headers: headers || {},
            params: params || null
          }).then(
            data => {
              resolve(mappingFunction(data.body))
            },
            error => {
              reject(error)
            }
          ).finally(() => {
            this.removePromise(route, method, body, params, headers)
          })
        }
      }
    })
    this.setPromise(route, method, body, params, promise, headers)
    return promise
  }
}
